import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Mobile = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      fill={fill}
      viewBox="0 0 16 17"
      {...rest}
    >
      <path d="M13.334 12.383H2.667a.333.333 0 1 1 0-.666h10.667a.334.334 0 0 1 0 .666Z" />
      <path d="M12 15.717H4a1.67 1.67 0 0 1-1.666-1.666v-12A1.669 1.669 0 0 1 4.001.385h8a1.669 1.669 0 0 1 1.666 1.666v12A1.669 1.669 0 0 1 12 15.717ZM4 1.051a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1H4Z" />
      <path d="M8 3.05a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" />
    </svg>
  );
};

Mobile.category = 'product';

Mobile.displayName = 'Mobile';
